/* In-browser Ed25519 SSH key generation for the onboarding page.
 *
 * The private key is generated here, in the operator's browser, and only ever
 * leaves it as a file download. It is never put in the submit payload and
 * never reaches the server -- AWS Transfer only ever needs the public half.
 * See docs/superpowers/specs/2026-07-28-onboard-page-rework-design.md.
 */
import { getKeys } from "ed25519-keygen/ssh";

export interface SshKeyPair {
  /** OpenSSH one-liner: "ssh-ed25519 AAAA... <comment>" -- this is what we submit. */
  publicKey: string;
  /** OpenSSH PEM block: "-----BEGIN OPENSSH PRIVATE KEY-----..." -- download only. */
  privateKey: string;
  fingerprint: string;
}

export const DEFAULT_COMMENT = "scadox-portal";
export const PRIVATE_KEY_FILENAME = "id_ed25519";

export function generateSshKeyPair(comment: string = DEFAULT_COMMENT): SshKeyPair {
  const seed = new Uint8Array(32);
  crypto.getRandomValues(seed);
  const keys = getKeys(seed, comment);
  return { publicKey: keys.publicKey, privateKey: keys.privateKey, fingerprint: keys.fingerprint };
}

/** Save the private key as a file, entirely client-side (no server round-trip). */
export function downloadPrivateKey(privateKey: string, filename: string = PRIVATE_KEY_FILENAME): void {
  const url = URL.createObjectURL(new Blob([privateKey], { type: "application/x-pem-file" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
